import React, {Component} from 'react';
import ReactTable from 'react-table';
import {application, reactTableText} from '../../constants/configs';
import {keyBy, mapValues, omit, lowerCase, values} from 'lodash';
import Api from '../../services/Api';
import moment from 'moment';
import {
  i18nizeDate,
  getDatePickerProps,
  numberWithCommas,
  mapStatus,
  getStatusColor,
  getTypeColor,
  mapTnxType,
  mapWithdrawError
} from '../../helpers/Utils';
import {withTranslation} from "react-i18next";
import ToolTip from '../../components/ToolTip';
import TransactionDetails from '../TransactionDetails';
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';
import {DateTimePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import {NotificationManager} from "../../components/common/react-notifications";
import fa_IR from "../../constants/locales";
import i18n from '../../services/i18n';
import JalaliUtils from '@date-io/jalaali';
import MomentUtils from '@date-io/moment';
import {store} from '../../AppRenderer';
import Rbac from "../../components/Rbac";
import {Button} from "reactstrap";

class Regular extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transactions: [],
      pages: -1,
      loading: true,
      selectedStartDate: null,
      selectedEndDate: null,
      refreshing: false,
      expanded: {},
    };
    this.tokens = keyBy(store.getState().general.tokens, 'symbol');
  }

  fetchData = async state => {
    try {
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/user-transactions',
        null,
        {
          params: {
            userId: this.props.userId,
            offset,
            limit: state.pageSize,
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'timestamp') : null),
            ...(this.state.selectedStartDate ? {createdFrom: moment(this.state.selectedStartDate).toISOString()} : null),
            ...(this.state.selectedEndDate ? {createdTo: moment(this.state.selectedEndDate).toISOString()} : null),
          }
        },
      );
      this.setState({
        transactions: data.transactions,
        pages: data.totalPage,
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  fireFetchData = async () => {
    await this.fetchData(this.table.state);
  };

  handleDateChange = (type, date) => {
    this.setState({
      [type]: date,
    });
  };

  getColumns = t => [
    {
      Header: t('Payment Id'),
      accessor: 'id',
      // filterable: true,
    },
    {
      Header: t('Token'),
      accessor: 'token',
      filterable: true,
      Filter: ({filter, onChange}) => (
        <select
          style={{width: '100%'}}
          value={filter ? filter.value : t('all')}
          onChange={event => onChange(event.target.value)}
        >
          <option value="">{t('all')}</option>
          {values(this.tokens).map(token => (
            <option key={token.symbol} value={token.symbol}>{token.localeName}</option>
          ))}
        </select>
      ),
      Cell: props => <span>{this.tokens[props.value] ? this.tokens[props.value].localeName : props.value}</span>,
    },
    {
      Header: t('Operation Type'),
      accessor: 'type',
      // filterable: true,
      // Filter: ({filter, onChange}) => (
      //   <select
      //     style={{width: '100%'}}
      //     value={filter ? filter.value : t('all')}
      //     onChange={event => onChange(event.target.value)}
      //   >
      //     <option value="">{t('all')}</option>
      //     <option value="DEPOSIT">{t('deposit')}</option>
      //     <option value="WITHDRAW">{t('withdraw')}</option>
      //   </select>
      // ),
      Cell: props => <span className={getTypeColor(lowerCase(props.value))}>
        {t(lowerCase(props.value))}
      </span>,
    },
    {
      Header: t('Transaction Type'),
      accessor: 'transaction_type',
      // filterable: true,
      // Filter: ({filter, onChange}) => (
      //   <select
      //     style={{width: '100%'}}
      //     value={filter ? filter.value : t('all')}
      //     onChange={event => onChange(event.target.value)}
      //   >
      //     <option value="">{t('all')}</option>
      //     <option value="BLOCKCHAIN">{t('Blockchain')}</option>
      //     <option value="BANK_PAYMENT">{t('Bank Payment')}</option>
      //   </select>
      // ),
      Cell: props => <span>{mapTnxType(props.value)}</span>,
    },
    {
      Header: t('Amount'),
      accessor: 'amount',
      minWidth: 120,
      Cell: props => <span>{numberWithCommas(Number(props.value))}</span>,
    },
    {
      Header: t('Status'),
      accessor: 'status',
      filterable: true,
      Filter: ({filter, onChange}) => (
        <select
          style={{width: '100%'}}
          value={filter ? filter.value : t('all')}
          onChange={event => onChange(event.target.value)}
        >
          <option value="">{t('all')}</option>
          <option value="WAITING">{t('Waiting')}</option>
          <option value="ACCEPTED">{t('Accepted')}</option>
          <option value="SUBMITTED">{t('Registered')}</option>
          <option value="PENDING">{t('Pending')}</option>
          <option value="CONFIRMED">{t('Confirmed')}</option>
          <option value="REJECTED">{t('Rejected')}</option>
        </select>
      ),
      Cell: props => <div>
        <span className={getStatusColor(props.value)}>{mapStatus(props.value)}</span>
        {props.value === 'REJECTED' &&
        !!props.original.error ?
          <ToolTip id={props.original.id} text={mapWithdrawError(props.original.error)}>
            <span className="text-large text-info">
              <i className="icon-Information mx-2"/>
            </span>
          </ToolTip>
          :
          null
        }
      </div>,
    },
    {
      Header: t('Date'),
      accessor: 'timestamp',
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      minWidth: 120,
      filterable: true,
      Filter: ({onChange}) => (
        <ThemeProvider theme={createMuiTheme({
          typography: {
            fontFamily: 'IRANSans',
          },
        })}>
          <MuiPickersUtilsProvider
            utils={i18n.language === fa_IR ? JalaliUtils : MomentUtils}
            locale={i18n.language}
          >
            <DateTimePicker
              {...getDatePickerProps()}
              value={this.state.selectedStartDate}
              TextFieldComponent={props => <input style={{width: '100%'}} placeholder={t('start date')} {...props} />}
              onChange={date => {
                this.handleDateChange('selectedStartDate', date);
                onChange(date);
              }}
            />
            <div style={{height: 4}} />
            <DateTimePicker
              {...getDatePickerProps()}
              value={this.state.selectedEndDate}
              TextFieldComponent={props => <input style={{width: '100%'}} placeholder={t('end date')} {...props} />}
              onChange={date => {
                this.handleDateChange('selectedEndDate', date);
                onChange(date);
              }}
            />
          </MuiPickersUtilsProvider>
        </ThemeProvider>
      ),
    },
    {
      Header: t('Actions'),
      width: 60,
      accessor: 'status',
      Cell: props => {
        if (props.original.type === "WITHDRAW" && props.value === "ACCEPTED") {
          return (
            <div className='d-flex flex-row align-items-center justify-content-around'>
              <ToolTip id={`cancel_${props.original.id}`} text={t('Cancel Withdraw')}>
                <i
                  className="icon-Close text-danger text-one font-weight-bold cursor-pointer"
                  onClick={async () => {await this.cancelWithdraw(props.original.id);}}
                />
              </ToolTip>
            </div>
          );
        }
        return null;
      },
      show: application.supportV2 && Rbac.hasPermission('delete_user-withdraws'),
    },
  ];

  cancelWithdraw = async tnxId => {
    const {t, userId} = this.props;
    try {
      await Api.invoke('DELETE', `/v2/admin-ui/withdraws/${tnxId}`, {
        userId,
      });
      NotificationManager.success(t('Withdraw transaction canceled successfully'), t('Message'));
      await this.fetchData(this.table.state);
    } catch (e) {
      console.log("error: ", e);
    }
  };

  onExpanded = (newExpanded, index) => {
    this.setState({
      expanded: {
        ...this.state.expanded,
        [index[0]]: !!newExpanded[index[0]],
      },
    });
  };

  updateList = (index, params) => {
    const {transactions} = this.state;
    let list = [...transactions];
    list.splice(index, 1, {...transactions[index], ...params});
    this.setState({transactions: list});
  };

  refreshList = async () => {
    const {t} = this.props;
    this.setState({refreshing: true});
    await this.fetchData(this.table.state);
    this.setState({refreshing: false});
    NotificationManager.info(t('Transactions list updated successfully'), t('Message'));
  };

  render() {
    const {t} = this.props;
    const {transactions, pages, expanded, loading, refreshing} = this.state;
    return (
      <div style={{marginTop: 20}}>
        <div className="d-flex flex-row align-items-center justify-content-end mb-2">
          <Button
            outline
            disabled={refreshing || loading}
            className="d-flex align-items-center justify-content-center"
            onClick={this.refreshList}>
            <i className='icon-File-Refresh text-large'/>
            <span className="mx-1">{t('Refresh')}</span>
          </Button>
        </div>
        <ReactTable
          manual
          ref={el => {this.table = el;}}
          className="-highlight"
          data={transactions}
          pages={pages}
          loading={loading}
          sortable={false}
          resizable={true}
          expanded={expanded}
          onPageChange={() => {this.setState({expanded: {}});}}
          onExpandedChange={this.onExpanded}
          onFetchData={this.fetchData}
          columns={this.getColumns(t)}
          defaultPageSize={10}
          style={{
            width: '100%',
          }}
          {...reactTableText}
          SubComponent={row => {
            const {original} = row;
            return (
              <TransactionDetails
                transaction={{...original, index: row.index}}
                updateList={this.updateList}
              />
            );
          }}
        />
      </div>
    );
  }
}

export default withTranslation()(Regular);
